import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";
import { useTranslation } from "react-i18next";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import Stars from "../Stars/Stars";
import Tooltip from "@/Components/Tooltip/Tooltip";

export interface ProductReviewsProps extends ModalProps {}

const ProductReviewsModal = ({ ...props }: ProductReviewsProps) => {
  const { t } = useTranslation("", { keyPrefix: "product_review_page" });
  const [{ comments, name, rating, reviewCount }] = useModalMeta();
  const setModal = useSetModal();

  return (
    <Modal
      fullHeight
      width={{ _: "90%", md: "40%" }}
      onExit={() => setModal("")}
      {...props}>
      
      <ModalTitle mb="2rem" p="0">
        {t("comments", { name: name })}
      </ModalTitle>
      <div className="ml-auto flex items-center gap-8">
        <Stars size="2rem" rating={rating} />
        <Tooltip content=



        {t("reviewCount")}><div><span style={{ fontWeight: "bold" }}>
              {` ( ${reviewCount} )`}</span></div></Tooltip>
      </div>
      <ol className="font-semibold">
        {comments.map((comment: string, index) =>
        <li key={index} className="p-[1rem]">
            {comment}
          </li>
        )}
      </ol>
    </Modal>);

};

export default ProductReviewsModal;